function domReady (callbackFn: () => void) {

	document.addEventListener('DOMContentLoaded', callbackFn);

}

export default domReady;
